import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6d41f42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-text": "正在加载数据，请稍候" }
const _hoisted_2 = { class: "flex-contants" }
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = { style: {"text-align":"center"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 提 交 ")

import { reactive, unref, ref } from 'vue';
import { FormRules, ElForm, ElMessage, ElMessageBox } from 'element-plus';
import { GbDialog } from '@/components/GbDialog/Index';
import { useDictionary } from '@/store/dictionary.store';
import { GetStampDpListApi } from '@/apis/basics/stamps.api';
import { CtAgreeApi } from '../../../apis/contract/contract.api';

/* Dtos */
import { StampUseDto } from '../../../apis/contract/contract.type';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const { getName } = useDictionary();

const elFormRef = ref<ComponentRef<typeof ElForm>>();
const stampList = ref<any[]>([]);

const state = reactive({
	show: false,
	loading: false,
	detail: {} as any,
});

const formRules = reactive<FormRules>({
	stamp_id: [{ required: true, message: '请选择合同用印', trigger: 'blur' }],
	file_total: [{ required: true, message: '请输入用印文件梳理', trigger: 'blur' }],
});

const auditSchema = reactive<StampUseDto>({
	id: '',
	revision: '',
	stamp_id: '',
	file_total: 1,
	remark: '',
});

const load = {
	/* 获取下拉列表 */
	getStampDropdownList: async (mainstayId: string) => {
		const { succeeded, data } = await GetStampDpListApi({ mainstay_id: mainstayId, current: 1, page_size: 99 });
		stampList.value = succeeded ? data || [] : [];
	},
};

const btnActions = {
	/* 提交数据 */
	submit: () => {
		unref(elFormRef)?.validate(async (isValid: boolean) => {
			if (!isValid) return;

			state.loading = true;

			const formData = unref(auditSchema);
			const { succeeded, errors } = await CtAgreeApi(formData);

			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				ElMessage.success('提交审批成功。');

				$emits('refresh', succeeded);
				state.show = false;
			}

			state.loading = false;
		});
	},
};

/* 打开对话框 */
const showDialog = async (contarct: any) => {
	unref(auditSchema).id = contarct.id;
	unref(auditSchema).revision = contarct.revision;

	await load.getStampDropdownList(contarct.mainstay_id);

	/* 如果没有印章，则提示消息 */
	if ((unref(stampList) ?? []).length > 0) {
		state.detail = contarct;
		state.show = true;
	} else {
		const msg = `该公司未设置印章管理人员，将无法进行申请用印。若需要用印，请联系管理员设置印章。`;
		ElMessageBox({ type: 'warning', lockScroll: false, title: '警告！', message: msg, buttonSize: 'small' });
	}
};

expose({ showDialog });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(state).show) = $event)),
    title: "用印申请",
    style: {"width":"600px"}
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"width":"80px"},
            disabled: _unref(state).loading,
            onClick: btnActions.submit,
            size: "small"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          ref_key: "elFormRef",
          ref: elFormRef,
          model: _unref(auditSchema),
          rules: _unref(formRules),
          "label-position": "top",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "合同编号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(state).detail.no,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).detail.no) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "合同名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(state).detail.name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).detail.name) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "印章",
                      prop: "stamp_id"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(auditSchema).stamp_id,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(auditSchema).stamp_id) = $event)),
                          style: {"width":"100%"},
                          placeholder: "请选择本次合同用印"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stampList.value, (stamp) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: stamp.id,
                                label: stamp.stamp_name,
                                value: stamp.id
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", null, _toDisplayString(`${stamp.stamp_name}(${stamp.stamp_no})`), 1),
                                    _createElementVNode("div", null, _toDisplayString(_unref(getName)('stamp_type', stamp.stamp_type)), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "用印文件数量(一式N份)",
                      prop: "file_total"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          style: {"width":"100%"},
                          modelValue: _unref(auditSchema).file_total,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(auditSchema).file_total) = $event)),
                          min: 1,
                          max: 10,
                          placeholder: "用印文件数量(一式N份)"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "申请备注",
                      prop: "remark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(auditSchema).remark,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(auditSchema).remark) = $event)),
                          type: "textarea",
                          "show-word-limit": "",
                          rows: "6",
                          maxlength: "150",
                          placeholder: "用印申请备注"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})